export default __webpack_public_path__ + "static/economic-performance-13857c420c80cf15307b00bee23e30f9.png";